import { window } from '../window.js';
import { Dialog } from './dialog.js';

/**
 * Error dialog.
 */
class ErrorDialog extends Dialog {
  static bodyMarkup = `<form class='default'><span></span></form>`;

  static buttons = {
    cancel: {
      label: 'Close',
      default: true,
    },
  };

  static get selectors() {
    const baseSelectors = super.selectors;
    return Object.assign({}, baseSelectors, {
      Message: `${baseSelectors.Body} .default > span`,
    });
  }

  static get elements() {
    let s = this.selectors;
    return {
      messageElement: s.Message,
      titleElement: s.Title,
    };
  }

  initialize() {
    super.initialize();

    this.titleElement.innerHTML = this.title;
    this.messageElement.innerHTML = this.message;
    if (this.buttonLabel) {
      this.cancelButton.textContent = this.buttonLabel;
    }
  }
}

window.customElements.define('error-dialog', ErrorDialog);
